PJQ.views.contacts.Register = PJQ.views.contacts.BaseEditContactView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'register'),
		detectGroupLevels: true,
		canEdit: true
	},
	events: {
		"change .contact-edit-phone,.contact-edit-fax,.contact-edit-cell": "formatPhone",
		"keydown .contact-edit-phone-ext": "numbersOnly",
		"click .btn-continue": "register"
	},
	beforeFirstRender: function () {
		if (PJQ.app.session.contact != null) {
			this.model = PJQ.app.session.contact;
		}

		if (PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
			if (this.model != null) {
				this.options.masterUserId = this.model.get('masterUserId');
			}
			else {
				this.options.masterUserId = PJQ.constants.publicUserId;
			}

			if (this.model.get('masterUserId') === PJQ.constants.publicUserId) {
				this.options.fieldSettingsEnabled = true;
				PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.PREVENT_NATIONWIDE_WORK_AREAS, true);
			}
		}
		else if (PJQ.app.session.preferences.hasPref('portalOwner')) {
			this.options.masterUserId = PJQ.app.session.preferences.getPref('portalOwner');
		}

		return PJQ.views.contacts.BaseEditContactView.prototype.beforeFirstRender.call(this);
	},
	register: function () {
		let validate = this.validateCoreFields(),
			$scrollTo = validate.$scrollTo;

		if (!validate.valid) {
			new PJQ.Alert(this.$('.validation-error'), {
				type: 'danger',
				text: 'Required fields are empty or have an incorrect value'
			});

			if (_.size($scrollTo) > 0) {
				this.scrollTo($scrollTo.offset().top);
			}
		}
		else if (validate.valid) {
			if (this.groupSelector != null) {
				this.model.groups.reset(this.groupSelector.getGroupsData().all);
			}
			this.model.set('companyCustomFieldValues', this.companyCustomFieldsForm != null ? this.companyCustomFieldsForm.getChanged() : null);
			this.model.set('contactCustomFieldValues', this.contactCustomFieldsForm != null ? this.contactCustomFieldsForm.getChanged() : null);
			this.model.set({
				groups: _.map(this.model.groups.models, function (group) {
					return {
						groupId: group.id,
						isDeleted: group.get('isDeleted')
					}
				})
			});
			this.model.set({
				workAreas: _.map(this.model.workAreas.models, function (workArea) {
					return {
						contactWorkAreaId: workArea.id,
						workAreaId: workArea.get('workAreaId'),
						isDeleted: workArea.get('isDeleted')
					}
				})
			});
			new PJQ.ajax.Request({
				endpoint: '/contacts/register',
				data: this.model
			}).post().done(_.bind(function (response) {
				if (this.model.isNew() && response.id > 0) {
					this.model.set('contactId', response.id);
					this.model.set('contactCompanyId', response.contactCompanyId);
					this.model.set('userId', response.userId);
					PJQ.app.session.contact = this.model;
				} else if (response.id > 0) {
					this.model.set('isApprovalRequired', response.isApprovalRequired);
					PJQ.app.session.contact = this.model;
				}

				if (PJQ.app.session.user != null) {
					PJQ.app.router.navigate('/', {
						trigger: true
					});
				}
				else if (this.model.get('userId') > 0) {
					new PJQ.views.contacts.RegisterAuth({
						el: PJQ.app.$el,
						mode: 'SIGN_IN'
					});
				}
				else {
					new PJQ.views.contacts.RegisterAuth({
						el: PJQ.app.$el,
						mode: 'SIGN_UP'
					});
				}
			}, this));
		}
	}
});

PJQ.views.contacts.RegisterAuth = PJQ.views.auth.Auth.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'register-auth'),
		routeToRoot: true
	},
	renderResetPassword: function () {
		new PJQ.views.auth.RequestResetPasswordModal();
	}
})

PJQ.modules.register = {
	routes: [
		{
			route: 'register',
			title: 'Register',
			name: 'register',
			callback: function () {
				if ((PJQ.app.session.user != null && PJQ.app.session.contact == null) || PJQ.app.session.get('portalId') !== PJQ.constants.panteraPortalId) {
					PJQ.app.router.routeToRoot();
				}
				else {
					new PJQ.views.contacts.Register({
						el: PJQ.app.$el
					});
				}
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.register.routes);
